import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Download } from "lucide-react";
import { Logo } from "../../components/Logo";
import { useI18n } from "../../lib/i18n";
import api from "../../lib/api";

export default function AdminInvoice() {
  const { sid } = useParams();
  const navigate = useNavigate();
  const { t } = useI18n();
  const token = localStorage.getItem("lc_token") || "";
  const url = `${api.defaults.baseURL}/admin/invoice/${sid}?auth=${token}`;

  return (
    <div className="min-h-screen bg-ink text-white">
      <header className="sticky top-0 z-40 glass border-b border-cardline px-4 py-3">
        <div className="mx-auto flex max-w-4xl items-center justify-between">
          <div className="flex items-center gap-3">
            <button onClick={() => navigate(-1)} data-testid="invoice-back-btn" className="grid h-9 w-9 place-items-center rounded-full border border-cardline bg-ink2/60 text-slate-300"><ArrowLeft size={18} /></button>
            <Logo size={26} />
            <span className="text-sm font-semibold text-slate-400">{t("invoice")}</span>
          </div>
          <a href={url} download data-testid="invoice-download-btn" className="flex items-center gap-2 rounded-full bg-gold px-4 py-2 text-sm font-bold text-ink"><Download size={15} /> {t("downloadPdf")}</a>
        </div>
      </header>
      <main className="mx-auto max-w-4xl p-4" data-testid="admin-invoice">
        <iframe src={url} title="invoice" className="h-[75vh] w-full rounded-2xl border border-cardline bg-white" />
      </main>
    </div>
  );
}
